/** tm/legal/LegalPipeline.tsx — 법이 바뀌는 순서 안내 한 줄 (입법예고 → 국무회의 의결 → 국회 법안 → 공포 → 시행). 개요·상세 안에서만. onTab 이 있으면 단계를 눌러 그 구분으로
 *  정부 법령안은 입법예고부터, 의원 발의 법률안은 국회 법안부터 시작한다 (시행령·시행규칙은 국회를 거치지 않음) */
import { C, T } from '../components/ui';
import { MUTED } from './legalTheme';
import type { FeedTab } from './legalTypes';

const STEPS: { label: string; tab: FeedTab | null; tip: string }[] = [
  { label: '입법예고', tab: 'notice', tip: '정부가 법령안을 미리 알리고 의견을 받는 단계 (주로 시행령·시행규칙)' },
  { label: '국무회의', tab: 'cabinet', tip: '정부 법령안이 국무회의를 통과한 단계 — 시행령은 곧 공포, 법률안은 국회로 제출' },
  { label: '국회 법안', tab: 'bill', tip: '국회에서 심사 중인 법률안 (의원 발의는 여기서 시작) — 시행령·시행규칙은 거치지 않음' },
  { label: '공포', tab: 'law', tip: '법령이 확정되어 관보에 실린 단계 — 구분 「법령」' },
  { label: '시행', tab: null, tip: '실제로 적용되는 날 — 법령의 「시행 D-n」' },
];

export default function LegalPipeline({ stage, onTab }: { stage: FeedTab; onTab?: (t: FeedTab) => void }) {
  if (stage !== 'law' && stage !== 'bill' && stage !== 'notice' && stage !== 'cabinet') return null;
  return (
    <div aria-label="법이 바뀌는 순서" style={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', fontSize: T.sm, color: MUTED, margin: '0 0 12px' }}>
      <span style={{ marginRight: 4 }}>법이 바뀌는 순서</span>
      {STEPS.map((s, i) => {
        const on = s.tab === stage;
        const st = { padding: '2px 7px', borderRadius: 10, fontSize: T.sm, fontWeight: on ? 700 : 500, color: on ? C.accent : C.sub, background: on ? C.accentLt : C.white, border: `1px solid ${on ? C.accent : C.border}`, fontFamily: 'inherit' } as const;
        return (
          <span key={s.label} style={{ display: 'inline-flex', alignItems: 'center', gap: 2 }}>
            {i > 0 && <span aria-hidden="true" style={{ color: C.borderDk }}>→</span>}
            {s.tab && onTab && !on
              ? <button type="button" className="lw-f" title={s.tip} onClick={() => s.tab && onTab(s.tab)} style={{ ...st, cursor: 'pointer' }}>{s.label}</button>
              : <span title={s.tip} aria-current={on ? 'step' : undefined} style={st}>{s.label}</span>}
          </span>
        );
      })}
    </div>
  );
}
